
import {NgModule, ApplicationRef, LOCALE_ID} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';
import { AuthModule, LoadingIconModule } from 'shared-angular-components-avla';
import { NgHcaptchaModule } from 'ng-hcaptcha';

/*
 * Platform and Environment providers/directives/pipes
 */
import { routing } from './app.routing';
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';


// Core providers
import { CommonModule, DatePipe, registerLocaleData } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localeEsCl from '@angular/common/locales/es-CL';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsPe from '@angular/common/locales/es-PE';
import {
	ChartJsModule,
	ConnectivityCheckModule,
	CoreModule,
	I18nModule,
	InfoMessageNotifierTwoModule,
	MoneyAvlaPipe,
	MoneyFormatPipe,
	PanelServiceSelectorModule,
	SharedAngularComponentsAvlaModule,
	SmartadminModule
} from "shared-angular-components-avla";
import {
	CountrySelectionModule
} from './components/country-selection/country-selection.module';
import { DevModule } from './components/development-environment/dev.module';


import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AngularDelegate, ModalController } from '@ionic/angular';

import { BaseAngularAvlaModule } from 'base-angular-avla';
import { NgxCaptchaModule } from 'ngx-captcha';
import { BRAZIL, CHILE, MEXICO, PERU, UNITED_STATES_TEXAS } from 'shared-angular-components-avla/country/country.constants';
import { CountryModule } from 'shared-angular-components-avla/country/country.module';
import { CountriesService } from './countries.service';
import { LanguageModule } from 'shared-angular-components-avla/language/language.module';
import { SPANISH_LANGUAGE, PORTUGUESE_LANGUAGE, ENGLISH_LANGUAGE } from 'shared-angular-components-avla/language/language.constants';
import { ClientService } from './shared';



// borrar los import de las vistas generadas aqui
//registerLocaleData(localeEsCl, 'es');
registerLocaleData(localeEsCl, 'es-CL');
registerLocaleData(localeEsPe, 'es-PE');
registerLocaleData(localeEn, 'en')
registerLocaleData(localeEsMx, 'es-MX');

// Application wide providers
const APP_PROVIDERS = [
	...APP_RESOLVER_PROVIDERS,
	AppState
];

type StoreType = {
	state: InternalStateType,
	restoreInputValues: () => void,
	disposeOldHosts: () => void
};

const staticCountries = [CHILE, MEXICO, BRAZIL, PERU, UNITED_STATES_TEXAS];

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
	bootstrap: [ AppComponent ],
	declarations: [
		AppComponent

// borrar los modulos agregados abajo de AppComponent
	],
	imports: [ // import Angular's modules
		ChartJsModule,
		BrowserModule,
		BrowserAnimationsModule,
		FormsModule,
		HttpClientModule,
		CoreModule,
		I18nModule,
		TextMaskModule,
		SmartadminModule,
		CommonModule,
		ConnectivityCheckModule,
		SharedAngularComponentsAvlaModule.forRoot(),
		CountryModule.forRoot('RISK', "-", null, staticCountries, false),
		LanguageModule.forRoot("RISK", "-", [SPANISH_LANGUAGE,PORTUGUESE_LANGUAGE,ENGLISH_LANGUAGE]),
		BaseAngularAvlaModule.forRoot(),
		LoadingIconModule,
		CountrySelectionModule,
		AuthModule.forRoot(false),
		DevModule,
		PanelServiceSelectorModule,
		NgxCaptchaModule,
		NgHcaptchaModule.forRoot(),
		InfoMessageNotifierTwoModule,
		routing
	],
	exports: [
	],
	providers: [ // expose our Services and Providers into Angular's dependency injection
		// ENV_PROVIDERS,
		APP_PROVIDERS,
		DatePipe,
		{ provide: LOCALE_ID, useValue: 'es-CL' },
		MoneyFormatPipe,
		MoneyAvlaPipe,
		CountriesService,
		ModalController,
		StatusBar,
		AngularDelegate,
		{provide: 'urlBasePathStateMachineService', useValue: {'apiSuffix': '/api-segurocredito'}},
		{provide: 'urlBasePathApprobationFlowService', useValue: '/api-segurocredito'},
		ClientService
	]
})
export class AppModule {
	constructor(
		public appRef: ApplicationRef,
		public appState: AppState
	) {}
}
